<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { setToken } from '@/utils/authority'

export default {
  beforeCreate() {
    const { token } = this.$route.query

    token && setToken(token)

    this.$store.dispatch('setSystem')
    this.$store.dispatch('dict/init')
  }
}
</script>
